import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/ui/Button";
import { cn } from "@/lib/utils";

interface AnalysisLinkProps {
  hasLink?: boolean;
  className?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * 分析リンクボタンコンポーネント
 */
const AnalysisLink: React.FC<AnalysisLinkProps> = ({ hasLink, onClick, className = "" }) => {
  const { t: tCommon } = useTranslation("common");

  if (!hasLink) return null;

  return (
    <Button
      onClick={onClick}
      className={cn("ml-auto mt-[-1px] min-w-[46px] px-2 text-xs shadow-[0px_2px_#3C569D]", className)}
      size="sm"
      variant="secondary"
    >
      {tCommon("button.analyze")}
    </Button>
  );
};

export default AnalysisLink;
